"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CMS_CONTENT_DATA_TYPES = exports.convertContentDataType = exports.extractConfigFromContentData = exports.generateChildrenRemotesDependencies = exports.generatePlaceholderHtmlFrom = exports.generateHtmlFrom = exports.generateServerSideHtmlFrom = exports.getWebComponentMFENameBy = exports.getAngularWebComponentSelector = void 0;
var environment_helper_1 = require("../helpers/environment.helper");
var mfe_1 = require("../mfe");
function getAngularWebComponentSelector(__mfeName__, id) {
    return "".concat(getWebComponentMFENameBy(__mfeName__), "[data-id='").concat(id, "']");
}
exports.getAngularWebComponentSelector = getAngularWebComponentSelector;
function getWebComponentMFENameBy(__mfeName__) {
    return __mfeName__.replace(/[A-Z]/g, function (match, offset) {
        return (offset > 0 ? "-" : "") + match.toLowerCase();
    });
}
exports.getWebComponentMFENameBy = getWebComponentMFENameBy;
function generateServerSideHtmlFrom(props) {
    var __serverSideHtml__ = props.__serverSideHtml__;
    if (__serverSideHtml__) {
        return __serverSideHtml__;
    }
    else if (environment_helper_1.EnvironmentHelper.isRunningTest()) {
        return generateHtmlFrom(props);
    }
    else {
        return null;
    }
}
exports.generateServerSideHtmlFrom = generateServerSideHtmlFrom;
function generateHtmlFrom(props) {
    var __serverSideHtml__ = props.__serverSideHtml__;
    return __serverSideHtml__
        ? __serverSideHtml__
        : generatePlaceholderHtmlFrom(props);
}
exports.generateHtmlFrom = generateHtmlFrom;
function generatePlaceholderHtmlFrom(props) {
    var placeholderHtml = "";
    if (typeof props === "object" && "__mfeName__" in props) {
        var children = props.children, __serverSideHtml__ = props.__serverSideHtml__, __host__ = props.__host__, __deps__ = props.__deps__, dataProps = __rest(props, ["children", "__serverSideHtml__", "__host__", "__deps__"]);
        var __mfeName__ = dataProps.__mfeName__, id = dataProps.id;
        var selector = getWebComponentMFENameBy(__mfeName__);
        var childrenHTML = !!children && "props" in children ? generateHtmlFrom(children.props) : "";
        var dataPropsString = void 0;
        try {
            var otherProps = !!__host__
                ? {
                    __host__: {
                        url: __host__.url,
                        pageProperties: __host__.pageProperties,
                    },
                }
                : {};
            dataPropsString = JSON.stringify(__assign(__assign({}, dataProps), otherProps));
        }
        catch (error) {
            dataPropsString = "";
        }
        placeholderHtml = "<".concat(selector, " data-id=\"").concat(id, "\" data-props='").concat(dataPropsString, "'>").concat(childrenHTML, "</").concat(selector, ">");
    }
    return placeholderHtml;
}
exports.generatePlaceholderHtmlFrom = generatePlaceholderHtmlFrom;
function generateChildrenRemotesDependencies(allRemoteDependencies) {
    return allRemoteDependencies.reduce(function (acc, dependency) {
        var _a, _b;
        if (!!dependency &&
            typeof dependency.props === "object" &&
            Object.keys(dependency.props).length > 0 &&
            "id" in dependency.props &&
            "__mfeName__" in dependency.props) {
            return __assign(__assign({}, acc), (_a = {}, _a[dependency.props.__mfeName__] = __assign(__assign({}, acc[dependency.props.__mfeName__]), (_b = {}, _b[dependency.props.id] = dependency, _b)), _a));
        }
        else {
            return acc;
        }
    }, {});
}
exports.generateChildrenRemotesDependencies = generateChildrenRemotesDependencies;
function extractConfigFromContentData(id, data) {
    if (data === void 0) { data = []; }
    return data.reduce(function (acc, el) {
        var _a;
        var __mfeName__ = convertContentDataType(el.type);
        var newEl = __mfeName__
            ? __assign({ id: "".concat(id, "-").concat(el.name), parentId: id, __mfeName__: __mfeName__ }, el) : el;
        return __assign(__assign({}, acc), (_a = {}, _a[el.name] = newEl, _a));
    }, {});
}
exports.extractConfigFromContentData = extractConfigFromContentData;
function convertContentDataType(type) {
    var _a;
    return (_a = {},
        _a[exports.CMS_CONTENT_DATA_TYPES.WCM_TextComponent] = mfe_1.MFE_NAMES.tpdShortText,
        _a[exports.CMS_CONTENT_DATA_TYPES.WCM_ShortTextComponent] = mfe_1.MFE_NAMES.tpdShortText,
        _a[exports.CMS_CONTENT_DATA_TYPES.WCM_NumericComponent] = mfe_1.MFE_NAMES.tpdNumber,
        _a[exports.CMS_CONTENT_DATA_TYPES.WCM_RichTextComponent] = mfe_1.MFE_NAMES.richText,
        _a[exports.CMS_CONTENT_DATA_TYPES.WCM_ImageComponent] = mfe_1.MFE_NAMES.tpdImage,
        _a[exports.CMS_CONTENT_DATA_TYPES.WCM_ReferenceComponent] = mfe_1.MFE_NAMES.tpdImage,
        _a[exports.CMS_CONTENT_DATA_TYPES.WCM_LinkComponent] = mfe_1.MFE_NAMES.tpdCta,
        _a[exports.CMS_CONTENT_DATA_TYPES.WCM_OptionSelectionComponent] = mfe_1.MFE_NAMES.tpdOptionSelection,
        _a)[type];
}
exports.convertContentDataType = convertContentDataType;
exports.CMS_CONTENT_DATA_TYPES = {
    WCM_AuthoringTemplate: "AuthoringTemplate",
    WCM_Category: "Category",
    WCM_Content: "Content",
    WCM_DateComponent: "DateComponent",
    WCM_FileComponent: "FileComponent",
    WCM_HTMLComponent: "HTMLComponent",
    WCM_ImageComponent: "ImageComponent",
    WCM_NumericComponent: "NumericComponent",
    WCM_PresentationTemplate: "PresentationTemplate",
    WCM_RichTextComponent: "RichTextComponent",
    WCM_ShortTextComponent: "ShortTextComponent",
    WCM_SiteArea: "SiteArea",
    WCM_Taxonomy: "Taxonomy",
    WCM_TextComponent: "TextComponent",
    WCM_Workflow: "Workflow",
    WCM_WorkflowStage: "WorkflowStage",
    WCM_LinkComponent: "LinkComponent",
    WCM_OptionSelectionComponent: "OptionSelectionComponent",
    WCM_ReferenceComponent: "ReferenceComponent",
};
